export class DomUtils {
	static GetElement(elementId) {
		const element = typeof elementId === "string" ? document.getElementById(elementId) : elementId;
		if (element == null) {
			throw new Error(`Element with id ${elementId} not found.`);
		}

		return element;
	}

	static FocusElement(elementId) {
		const element = DomUtils.GetElement(elementId);
		element.focus();
	}

	static ShowHide(isVisible, elementId) {
		const element = DomUtils.GetElement(elementId);
		element.style.display = isVisible ? "" : "none";
	}

	static OnEnter(elementId, callback, useKeyDown = false) {
		const element = DomUtils.GetElement(elementId);
		element.addEventListener(useKeyDown ? "keydown" : "keyup", (event) => {
			if (event.key === "Enter") {
				event.preventDefault();
				callback();
			}
		});
	}
}
